import { render } from "./VTaskPanel.vue?vue&type=template&id=547119e2&ts=true"
import script from "./VTaskPanel.vue?vue&type=script&lang=ts"
export * from "./VTaskPanel.vue?vue&type=script&lang=ts"

import "./VTaskPanel.vue?vue&type=style&index=0&id=547119e2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__